import { Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { RaModalComponent } from 'src/app/shared/components/ra-modal/ra-modal.component';

/**
 * Pergunta em quantas colunas as imagens selecionadas devem entrar.
 *
 * Só aparece quando o usuário escolheu mais de uma imagem: com uma só não há
 * distribuição a decidir. "1 coluna" cria um card por imagem (imagem inteira na
 * largura da página); 2 e 3 criam UM card de grupo com esse grid.
 */
@Component({
    selector: 'modal-image-columns',
    templateUrl: 'modal-image-columns.component.html',
    styleUrl: 'modal-image-columns.component.scss',
    imports: [RaModalComponent, TranslatePipe],
})
export class ModalImageColumnsComponent {
    /** Quantas imagens o usuário acabou de selecionar (aparece no subtítulo). */
    public imagesCount = input.required<number>();

    public close = output<void>();
    public columnsSelected = output<number>();

    /** Cada célula é uma "foto" na prévia do grid — sempre duas linhas. */
    public options = computed(() => [
        {
            columns: 1,
            titleKey: 'document.edit.imageColumns.oneColumn',
            descriptionKey: 'document.edit.imageColumns.oneColumnDescription',
            cells: [1, 2],
        },
        {
            columns: 2,
            titleKey: 'document.edit.imageColumns.twoColumns',
            descriptionKey: 'document.edit.imageColumns.twoColumnsDescription',
            cells: [1, 2, 3, 4],
        },
        {
            columns: 3,
            titleKey: 'document.edit.imageColumns.threeColumns',
            descriptionKey: 'document.edit.imageColumns.threeColumnsDescription',
            cells: [1, 2, 3, 4, 5, 6],
        },
    ]);
}
